import { render, staticRenderFns } from "./SalesItemEdit.vue?vue&type=template&id=8d52efe0&"
import script from "./SalesItemEdit.vue?vue&type=script&lang=js&"
export * from "./SalesItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports